import { ApiManager } from '../core/api-manager';

/**
 * Assegnazione di una sala al suo condominio (api/custom_classes/SalaEngine.php).
 *
 * Non passa da DataManager perche' `idUserGroup` la CRUD del framework non lo
 * accetta ne' in creazione ne' in modifica: lo timbra da sola con il gruppo di
 * chi scrive. Per l'amministratore globale, che di condomini ne ha davanti
 * piu' d'uno, quel timbro e' sempre sbagliato.
 */
async function assegnaSala(idSala, idUserGroup) {
    let body = {
        idSala: idSala,
        idUserGroup: idUserGroup
    }
    let response = await ApiManager.sendAuthenticatedRequest('/custom/assegna_sala', body)
    return response;
}


export const SaleManager = {
    assegnaSala: assegnaSala
};
